module.exports = __webpack_public_path__ + "img/contact.167e7612.jpg";